import React from 'react';
import MonthRecordingsUI from './MonthRecordingsUI';

const February = () => <MonthRecordingsUI month="February" />;

export default February;
